import { login, logout, getInfo, getPermissionsList } from "@/api/user";
import {
  getToken,
  setToken,
  removeToken,
  removeCookies,
  getCookies,
} from "@/utils/auth";
import { resetRouter } from "@/router";
import store from "@/store";
const getDefaultState = () => {
  return {
    token: getToken(),
    name: "",
    avatar: "",
    watermark: "",
    userType: "",
    transportCompanyIds: "",
  };
};

const state = getDefaultState();

const mutations = {
  RESET_STATE: (state) => {
    Object.assign(state, getDefaultState());
  },
  SET_TOKEN: (state, token) => {
    state.token = token;
  },
  SET_NAME: (state, name) => {
    state.name = name;
  },
  SET_AVATAR: (state, avatar) => {
    state.avatar = avatar;
  },
  SET_ROLES: (state, roles) => {
    state.roles = roles;
  },
  SET_WaterMark: (state, watermark) => {
    state.watermark = watermark;
  },
  SET_USER_TYPE: (state, userType) => {
    state.userType = userType;
  },
  SET_TRANSPORT_COMPANY_IDS: (state, transportCompanyIds) => {
    state.transportCompanyIds = transportCompanyIds;
  },
};

const actions = {
  // user login
  login({ commit }, userInfo) {
    const { username, password, captcha } = userInfo;
    return new Promise((resolve, reject) => {
      var thisToken = getCookies("loginToken");
      login({
        loginName: username.trim(),
        password: password.trim(),
        token: thisToken,
        captcha: captcha.trim(),
      })
        .then((response) => {
          const { result, data } = response;
          // 登录成功
          if (result == "10000") {
            commit("SET_TOKEN", thisToken);
            setToken(thisToken);
          }
          resolve();
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  // get user info
  getInfo({ commit, state }) {
    return new Promise((resolve, reject) => {
      getInfo(state.token)
        .then((response) => {
          const { data } = response;
          if (!data) {
            return reject("信息异常,请重新登录");
          }

          const {
            name,
            avatar,
            projectTitle,
            watermark,
            userType,
            transportCompanyIds,
          } = data;
          commit("SET_NAME", name);
          commit("SET_AVATAR", avatar);
          commit("SET_WaterMark", watermark);
          commit("SET_USER_TYPE", userType);
          commit("SET_TRANSPORT_COMPANY_IDS", transportCompanyIds);
          store.dispatch("settings/changeTitle", projectTitle);
          // commit('SET_ROLES', 'admin')
          resolve(data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  // user logout
  logout({ commit, state }) {
    return new Promise((resolve, reject) => {
      logout(state.token)
        .then(() => {
          resetRouter();
          commit("RESET_STATE");
          removeToken(); // must remove  token  first
          // 重置 tagsView
          store.dispatch("tagsView/delAllViews", null, { root: true });
          resolve();
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  // 获取用户菜单权限
  getPermissionsList({ commit, state }) {
    return new Promise((resolve, reject) => {
      getPermissionsList()
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  // remove token
  resetToken({ commit }) {
    return new Promise((resolve) => {
      removeToken(); // must remove  token  first
      commit("RESET_STATE");
      resolve();
    });
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
